import React from 'react';
import { Outlet, useParams, Link, useLocation } from 'react-router-dom';

const AppointmentsView = () => {
  const params = useParams();
  const loc = useLocation();

  return (
    <>
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="main-content-label">Appointments</h6>
              </div>
              <div className="tabs-wrap">
                <div className="profile-tab tab-menu-heading mb-4">
                  <nav className="nav main-nav-line p-3 tabs-menu profile-nav-line bg-gray-100">
                    <Link
                      className={
                        "nav-link linkactive " +
                        (loc.pathname.includes(`/admin/management-section/upcoming-appointment/list`) ? " active" : "")
                      }
                      to={`/admin/management-section/upcoming-appointment/list/${1}`}
                    >
                      Upcoming Appointments
                    </Link>
                    <Link
                      className={
                        "nav-link linkactive " +
                        (loc.pathname.includes(`/admin/management-section/completed-appointment/list`) ? " active" : "")
                      }
                      to={`/admin/management-section/completed-appointment/list/${1}`}
                    >
                      Completed Appointments
                    </Link>
                    <Link
                      className={
                        "nav-link linkactive " +
                        (loc.pathname.includes(`/admin/management-section/feedback-appointment/list`) ? " active" : "")
                      }
                      to={`/admin/management-section/feedback-appointment/list/${1}`}
                    >
                      Feedback Appointments
                    </Link>
                     <Link
                      className={
                        "nav-link linkactive " +
                        (loc.pathname.includes(`/admin/management-section/cancelled-appointment/list`) ? " active" : "")
                      }
                      to={`/admin/management-section/cancelled-appointment/list/${1}`}
                    >
                      Cancelled Appointments
                    </Link>
                     <Link
                      className={
                        "nav-link linkactive " +
                        (loc.pathname.includes(`/admin/management-section/expired-appointment/list`) ? " active" : "")
                      }
                      to={`/admin/management-section/expired-appointment/list/${1}`}
                    >
                      Expired Appointments
                    </Link>
                    {/* <Link
                      className={
                        "nav-link linkactive " +
                        (loc.pathname.includes(`/admin/report-management/earning-report/list`) ? " active" : "")
                      }
                      to={`/admin/report-management/earning-report/list/${1}`}
                    >
                      Earning Report
                    </Link> */}
                  </nav>
                </div>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppointmentsView;
